const departments = {
    leader: 'Leitung',
    leaders: 'Abteilungsleitung',
    led_departments: 'Geleitete Abteilungen',
    edit_leaders: 'Leitung verwalten',
    add_leader: 'Hinzufügen',
    remove_leader: 'Entfernen',
    no_leaders: 'Keine Leitung festgelegt',
    local: 'Lokal verwaltet',
    managed_members: 'Mitglieder im Verwaltungsbereich',
    leader_scope_hint: 'Mitgliedschaften in geleiteten Abteilungen und Unterabteilungen verwalten.',
    leader_permission_hint: 'Die Leitung verwaltet Mitgliedschaften ihrer Abteilungen und Unterabteilungen, jedoch keine Organisationsrollen oder Hierarchien.',
    primary_synced: 'Die Hauptabteilung wird von Feishu verwaltet.',
    status_active: 'Aktiv',
    status_suspended: 'Gesperrt',
    status_departed: 'Ausgeschieden',
    status_pending: 'Aktivierung ausstehend',
    search: 'Suchen',
    previous_page: 'Vorherige Seite',
    next_page: 'Nächste Seite',
    directory_title: 'Organisationsmitglieder',
    member_name: 'Mitglied',
    search_members: 'Nach Name oder Benutzername suchen',
    include_descendants: 'Unterabteilungen einbeziehen',
    no_members: 'Keine passenden Mitglieder.',
    all_members: 'Alle Mitglieder',
    all_departments: 'Alle Abteilungen',
    edit_member: 'Abteilungen bearbeiten',
    add_child: 'Unterabteilung hinzufügen',
    expand_department: '{{name}} aufklappen',
    collapse_department: '{{name}} zuklappen',
    title: 'Abteilungen',
    description: 'Abteilungen und Mitgliederzuordnungen dieser Organisation verwalten.',
    create: 'Abteilung erstellen',
    edit: 'Abteilung bearbeiten',
    name: 'Abteilungsname',
    parent: 'Übergeordnete Abteilung',
    root: 'Keine übergeordnete Abteilung',
    id: 'Abteilungs-ID',
    members: 'Abteilungen der Mitglieder',
    member_id: 'Benutzer-ID des Mitglieds',
    primary: 'Hauptabteilung',
    none: 'Nicht festgelegt',
    assignments: 'Abteilungszuordnungen',
    no_assignments: 'Noch keine Abteilungszuordnungen.',
    assignment_hint: 'Lokale Abteilungen und optional eine Hauptabteilung zuweisen. Verzeichniszuordnungen sind schreibgeschützt.',
    empty: 'Noch keine Abteilungen.',
    readonly: 'Sie können Abteilungen und eigene Zuordnungen ansehen. Änderungen nimmt die Organisationsverwaltung vor.',
    load_error: 'Daten konnten nicht geladen werden. Bitte erneut versuchen.',
    mutation_error: 'Speichern fehlgeschlagen. Prüfen Sie Berechtigungen, Mitgliedschaft und Abteilungshierarchie.',
    loading: 'Wird geladen…',
    synced: 'Vom Verzeichnis verwaltet',
    choose: 'Abteilungen suchen',
    organizations_title: 'Organisationen und Abteilungen',
    organizations_description: 'Organisation auswählen, um ihre Abteilungen anzuzeigen oder zu verwalten.',
    no_organizations: 'Sie gehören keiner Organisation an. Kontaktieren Sie die Organisationsverwaltung.',
    organization: 'Aktuelle Organisation',
    choose_organization: 'Organisation auswählen',
    delete_title: 'Abteilung löschen',
    delete_description: '„{{name}}“ löschen? Verschieben Sie zuerst Mitglieder und Unterabteilungen.',
};
export default Object.freeze(departments);
